import api from './api';

export default {
    index(search=false,status=false , sort=false,page=1){
        return api.get(`${process.env.VUE_APP_URL}/competitions` , {params: {search:search , status:status, sort:sort , page:page}});
    },
    getCompletedCompetitionAdmin(search=false, sort=false,page=1 , status='ended'){
        return api.get(`${process.env.VUE_APP_URL}/competition/completedAdmin` , {params: {search:search , sort:sort , page:page , status:status}});
    },
    create(params){
        return api.post(`${process.env.VUE_APP_URL}/competitions` , params);
    },
    show(id){
        return api.get(`${process.env.VUE_APP_URL}/competitions/${id}`);
    }, start(id){
        return api.get(`${process.env.VUE_APP_URL}/competition/start/${id}`);
    },
    update(id , params){
        return api.put(`${process.env.VUE_APP_URL}/competitions/${id}` , params);
    },
    delete(id){
        return api.delete(`${process.env.VUE_APP_URL}/competitions/${id}`);
    },
    assignUsers(type , id , params){
        return api.post(`${process.env.VUE_APP_URL}/competitions/assign/${type}/${id}` , params);
    },
    assignUsersTraining(type , id , params){
        return api.post(`${process.env.VUE_APP_URL}/trainings/assign/${type}/${id}` , params);
    },
    getNotUsersAssigned(type , id){
        return api.get(`${process.env.VUE_APP_URL}/competitions/users/notAssigned/${type}/${id}`);
    },
    getNotUsersAssignedTraining(type , id){
        return api.get(`${process.env.VUE_APP_URL}/trainings/users/notAssigned/${type}/${id}`);
    },
    getUsersAssigned(id){
        return api.get(`${process.env.VUE_APP_URL}/competitions/users/assigned/${id}`);
    },
    getUsersAssignedTraining(id){
        return api.get(`${process.env.VUE_APP_URL}/trainings/users/assigned/${id}`);
    },
    deleteUserAssigned(id){
        return api.delete(`${process.env.VUE_APP_URL}/competitions/delete/user/assigned/${id}`);
    },
    deleteUserAssignedTraining(id){
        return api.delete(`${process.env.VUE_APP_URL}/trainings/delete/user/assigned/${id}`);
    },
    playCompetition(type , id){
        return api.put(`${process.env.VUE_APP_URL}/competitions/play/team/${id}` , {type:type});
    },
    playTraining(type , id){
        return api.put(`${process.env.VUE_APP_URL}/trainings/play/team/${id}` , {type:type});
    },
    getAssignedCompetitionsOfUsers(search=false,status=false , sort=false,page=1){
        return api.get(`${process.env.VUE_APP_URL}/user/assigned-competition` , {params: {search:search , status:status, sort:sort , page:page}});
    },
    getAssignedCompetitionsOfUsersCompleted(search=false,status=false , sort=false,page=1){
        return api.get(`${process.env.VUE_APP_URL}/user/assigned-competition/completed` , {params: {search:search , status:status, sort:sort , page:page}});
    },
    getAssignedTrainingsOfUsers(){
        return api.get(`${process.env.VUE_APP_URL}/user/assigned-training`);
    },
    deleteCompetitionUsers(id){
        return api.get(`${process.env.VUE_APP_URL}/competition/deleteCompetition/users/${id}`);
    }
}